import { useQuery } from 'react-query';
import { getMedia } from 'src/services/api/medias';

function useGetMedia(media, fileMIME, enabled = false) {
  return useQuery(['media', media], (key, media) => getMedia(media, fileMIME), { enabled });
}

export default useGetMedia;
